import React from "react";
import { AddLeavePlan } from "app/components/leave-plans/AddLeavePlan";
import { LeavePlansForMember } from "app/components/leave-plans/LeavePlansForMember";
import { checkUserHasMemberRole } from "app/services/app.state.service";
import "app/components/leave-plans/LeavePlanForMemberView.css";
import { HolidayListView } from "app/components/leave-plans/HolidayListView";
import { Grid } from "@mui/material";

export const LeavePlanForMemberView = () => {
    if(!checkUserHasMemberRole()) return;
    return (
        <div className="content-container" style={{width: "100%" }}>
            <Grid container spacing={6}>
                <AddLeavePlan/>
                <LeavePlansForMember/>
                <HolidayListView />
            </Grid>
        </div>
    );
}